import type { TonoRegistro } from '@/lib/marketing/geometriaBiblioteca';

// Un tono de registro por clase de fondo. La geometría da nombres de token, nunca hex ni clases, y
// el héroe y la Biblioteca los traducen aquí, una sola vez, para pintar la misma biblioteca.
export const CLASE_TONO: Readonly<Record<TonoRegistro, string>> = {
    'surface-2': 'bg-surface-2',
    'tint-accent': 'bg-tint-accent',
    'tint-accent-strong': 'bg-tint-accent-strong',
    'accent-blue': 'bg-accent-blue',
    ink: 'bg-ink',
};
